
import '../components/view360.css';

function View360() {

    return (
        <>
            <h1 className="text1">Experience your home virtually - 360<sup>o</sup>&nbsp;&nbsp;Rendering</h1>
      <iframe className="fimage" src="https://momento360.com/e/u/f877ddf0be4e4ec380202933a6201624?utm_campaign=embed&utm_so
  urce=other&heading=6.84&pitch=-0.95&field-of-view=100&size=medium"></iframe><br></br>
      <iframe className="fimage" src="https://momento360.com/e/u/2ff6a8f8e3e8409aa82cdc363570e640?utm_campaign=embed&utm_source=other&heading=0&pitch=0&field-of-view=75&size=medium"></iframe>
    <br/><br /><br />
        </>
    );
}
export default View360;